"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Cell;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function Cell(_ref) {
  var children = _ref.children,
      scope = _ref.scope,
      _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'td' : _ref$component;
  return ['string', 'number'].indexOf(_typeof(children)) !== -1 ? /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, !!scope && {
    scope: scope
  }, {
    dangerouslySetInnerHTML: {
      __html: children ? children.toString() : ''
    }
  })) : /*#__PURE__*/_react["default"].createElement(Tag, !!scope && {
    scope: scope
  }, children);
}